<template src="./badge.html"></template>

<script lang="ts">
export default {
  props: { type: String },
  computed: {
    typeClass() {
      return this.type ? `tt-o-badge--${this.type}` : ''
    }
  }
}
</script>

<style lang="scss" src="./badge.scss"></style>
